import { combineReducers } from "redux";
import { walletReducer } from "./Wallet";
import { docReducer } from "./Docs";
import { adminPanelReducer } from "./AdminPanel";

export const rootReducer = combineReducers({
  wallet: walletReducer,
  doc: docReducer,
  adminPanel: adminPanelReducer,
});
